import React, { useCallback, useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { spacing, icons, radius, themeLight, breakpoints } from '@naf/theme';
import { Text, TextVariant } from '@naf/text';
import { HelpOutline } from '@styled-icons/material-outlined/HelpOutline';
import { Help } from '@styled-icons/material/Help';
import { propValidationConfig } from '../propValidationConfig';
export const Tooltip = ({
  text,
  className
}) => {
  const [tooltipPos, setTooltipPos] = useState(0);
  const [isTooltipRightEdge, setIsTooltipRightEdge] = useState(false);
  const [isHover, toggleHover] = useState(false);
  const [isSelected, toggleSelected] = useState(false);
  const iconRef = useRef(null);
  useEffect(() => {
    if (!!iconRef.current) {
      if (typeof window !== 'undefined' && window.innerWidth < parseInt(breakpoints.m, 10)) {
        const rect = iconRef.current.getBoundingClientRect();
        const vpRightArea = window.innerWidth - window.innerWidth / 3;
        setIsTooltipRightEdge(rect?.right > vpRightArea);
      }
      setTooltipPos(iconRef.current.offsetLeft);
    }
  }, []);
  const Icon = useCallback(() => {
    if (isSelected) {
      return /*#__PURE__*/React.createElement(Help, {
        size: 24
      });
    } else if (isHover) {
      return /*#__PURE__*/React.createElement(Help, {
        size: 24
      });
    } else {
      return /*#__PURE__*/React.createElement(HelpOutline, {
        size: 24
      });
    }
  }, [isSelected, isHover]);
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(TooltipWrapper, {
    className: className,
    tabIndex: 0,
    ref: iconRef,
    onMouseEnter: () => toggleHover(true),
    onMouseLeave: () => toggleHover(false),
    onFocus: () => toggleSelected(true),
    onBlur: () => toggleSelected(false)
  }, Icon(), /*#__PURE__*/React.createElement(InfoBox, {
    tooltipPos: tooltipPos,
    isCloseToRightEdge: isTooltipRightEdge
  }, /*#__PURE__*/React.createElement(StyledText, {
    variant: TextVariant.Small
  }, text))));
};
export default Tooltip;
const Container = styled.div.withConfig({
  displayName: "tooltip__Container",
  componentId: "sc-8wl8b6-0"
})(["display:inline-flex;flex-basis:100%;margin:0;position:relative;"]);
const TooltipWrapper = styled.div.withConfig({
  displayName: "tooltip__TooltipWrapper",
  componentId: "sc-8wl8b6-1"
})(["display:flex;align-items:center;height:100%;color:", ";span{display:none;}svg{max-width:", ";max-height:", ";color:", ";}&:hover,&:focus{span{display:block;}}"], ({
  theme
}) => theme.typography ? theme.typography.defaultTextInverted : themeLight.typography.defaultTextInverted, icons.m, icons.m, ({
  theme
}) => theme.background ? theme.background.brandInverted : themeLight.background.brandInverted);
const InfoBox = styled.span.withConfig(propValidationConfig).withConfig({
  displayName: "tooltip__InfoBox",
  componentId: "sc-8wl8b6-2"
})(["position:absolute;left:0;bottom:", ";z-index:99;padding:", " ", ";min-width:calc(", "px + ", ");border-radius:", ";background:", ";&:after{content:' ';position:absolute;top:100%;left:calc(", "px + 0.5 * ", ");margin-left:-3px;border:6px solid;border-color:", " transparent transparent transparent;}@media (max-width:", "){left:", ";right:", ";&:after{", ";}}"], spacing.space32, spacing.space8, spacing.space12, props => props.tooltipPos, spacing.space12, radius.s, ({
  theme
}) => theme.background ? theme.background.brandInverted : themeLight.background.brandInverted, props => props.tooltipPos, spacing.space20, ({
  theme
}) => theme.background ? theme.background.brandInverted : themeLight.background.brandInverted, breakpoints.m, props => props.isCloseToRightEdge ? `auto` : `0`, props => props.isCloseToRightEdge ? `0` : `auto`, props => props.isCloseToRightEdge && `right: calc(${props.tooltipPos}px + 0.5 * ${spacing.space20}); left: auto;`);
const StyledText = styled(Text).withConfig({
  displayName: "tooltip__StyledText",
  componentId: "sc-8wl8b6-3"
})(["margin:0;"]);
//# sourceMappingURL=tooltip.js.map